export const INFINITY_EXTENSION_MODE = {
  promptGeneration: 'promptGeneration',
  variationsGeneration: 'variationsGeneration',
};

export const CANVAS_PROJECT_FORM_EVENT = {
  generationStarted: 'generationStarted',
  backClicked: 'backClicked',
  advancedOptionsToggled: 'advancedOptionsToggled',
};
